import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class Einwohnerzahl extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    jahr: number | null = null;
    kanton_id: number | null = null;
    gemeinde_id: number | null = null;
    einwohner: number | null = null;

    // view fields
    kanton_kuerzel: string | null = null;
    kanton: string | null = null;
    gemeinde: string | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'Einwohnerzahl';
    }
}

export async function createNewEinwohnerzahl(): Promise<Einwohnerzahl> {
    const einwohnerzahl = createModel(Einwohnerzahl, {});

    await einwohnerzahl.save();
    return einwohnerzahl;
}

export class EinwohnerzahlCollection extends BaseCollection<Einwohnerzahl> {
    protected modelCls = Einwohnerzahl;

    public getModelClassName(): string {
        return 'Einwohnerzahl';
    }
}
